import { ENV } from "../Utils";

export class BannerAPI {
  baseApi = ENV.BASE_API;

  // Método para preguntar a la IA
  async askAI(question, speech) {
    if (!question) return null;  // Devuelve null para indicar ausencia de datos
    try {
      const url = new URL(`${this.baseApi}/${ENV.API_ROUTES.THREEJSIA}`);
      url.searchParams.append('question', question);
      url.searchParams.append('speech', speech);

      const res = await fetch(url);
      const result = await res.json();
      //console.log("result", result);
      if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
      return result;
    } catch (error) {
      console.error("Error while fetching AI response:", error);
      return null;  // Devuelve null para manejar errores adecuadamente
    }
  }

  // Método para reproducir el mensaje
  async playMessage(message , teacher) {
    try {
      const url = new URL(`${this.baseApi}/${ENV.API_ROUTES.GETTEXT_TO_SPEECH}`);
      url.searchParams.append('text', message);
      url.searchParams.append('teacher', teacher);
      //console.log("teacher", teacher);  
  
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
  
      // Devuelve directamente la respuesta para ser manejada más adelante.
      //console.log("response", response);
      return response;
    } catch (error) {
      console.error("Error while fetching TTS response:", error);
      return null;  // Devuelve null para manejar errores adecuadamente
    }
  }
}
